import Button from "antd/lib/button";
import React, { Component } from "react";
import { Translate } from "react-localize-redux";
import { connect } from "react-redux";
import styled, { css } from "styled-components";
import { disableMfa, enableMFA, verifyMFAToken } from "../../../actions/auth";
import { getUserInfo } from "../../../actions/profile.js";
import { getUser } from "../../../utils";
import ConfirmModal from "./confirmModal.jsx";

const TwoFactorAuthWrapper = styled.div`
	display: flex;
	flex-direction: column;
	width: 100%;
	min-height: 156px;
	border-radius: 20px;
	background: var(--profile-page-wrapper-bg);
	padding: 15px 10px;
	gap: 10px;
	margin-bottom: 10px;

	.two-factor-auth {
		margin-top: 0;
	}

	.two-factor-auth-header {
		color: var(--profile-card-text-color);
		text-align: center;
		font-size: 12px;
		font-weight: 600;
		line-height: 20px;
		letter-spacing: 0.3px;
	}

	.two-factor-auth-container {
		color: var(--content-text-color);
		text-align: center;
		font-size: 10px;
		font-weight: 400;
		line-height: 12px;
		letter-spacing: 0.25px;
	}

	.ant-btn[disabled],
	.ant-btn[disabled]:hover,
	.ant-btn[disabled]:focus,
	.ant-btn[disabled]:active {
		background: linear-gradient(
			180deg,
			var(--main-color-light) 0%,
			var(--main-color-dark) 100%
		);
		color: #ffffff;
	}

	h3 {
		text-align: center;
		font-size: 12px;
		font-weight: 600;
		line-height: 20px;
		letter-spacing: 0.3px;
		margin: 0 0 10px 0;
	}

	.enabled-title {
		color: #18bb0c;
	}

	.notEnabled {
		color: #f0052f;
	}

	p {
		margin: 0 0 10px 0;
	}

	.two-factor-auth-enable-btn {
		align-items: center;
		display: flex;
		width: 100%;
		justify-content: center;
		border-radius: 25px;

		${window.HAS_LESS_BORDER_RADIUS &&
		css`
			border-radius: 10px;
		`}

		background: var(--profile-card-button-bg);
		color: var(--button-color);
		opacity: 0.6;

		svg {
			path {
				fill: var(--button-color);
			}
		}
	}
`;

export class TwoFactorAuth extends Component {
	constructor(props) {
		super(props);
		this.state = {
			confirmModalVisible: false,
			data: {},
		};
	}
	handleEnableMFA(e) {
		e.preventDefault();
		this.props.toggleLoading(true);
		this.props.enableMFA(
			(res) => {
				this.setState({ ...this.state, confirmModalVisible: true, data: res.data });
				this.props.toggleLoading(false);
			},
			(err) => {
				this.props.toggleLoading(false);
				console.log("err", err);
			}
		);
	}
	handleDisableMFA(e) {
		e.preventDefault();
		this.props.toggleLoading(true);
		this.props.disableMfa(
			(res) => {
				const user = getUser();
				user && this.props.getUserInfo();
				this.props.toggleLoading(false);
			},
			(err) => {
				this.props.toggleLoading(false);
				console.log("err", err);
			}
		);
	}
	handleOnClose() {
		this.setState({ ...this.state, confirmModalVisible: false });
		const user = getUser();
		user && this.props.getUserInfo();
	}
	render() {
		const { enabled, verifyMFAToken } = this.props;
		const { confirmModalVisible, data } = this.state;
		return (
			<Translate>
				{({ translate }) => (
					<TwoFactorAuthWrapper className="two-factor-auth">
						<ConfirmModal
							data={data}
							confirmModalVisible={confirmModalVisible}
							verifyMFAToken={verifyMFAToken}
							handleOnClose={this.handleOnClose.bind(this)}
						/>
						<div className="two-factor-auth-header">
							{translate("Two Factor Authentication")}
						</div>
						<div className="two-factor-auth-container">
							{!enabled ? (
								<h3 className={!enabled && "notEnabled"}>
									{translate("TWO_FACTOR_AUTH_INFO_H3")}
								</h3>
							) : (
								<h3 className="enabled-title">
									{translate("TWO_FACTOR_AUTH_INFO_H31")}
								</h3>
							)}
							<p>{translate("TWO_FACTOR_AUTH_INFO_P1")}</p>
						</div>
						<Button
							type="default"
							onClick={this[!enabled ? "handleEnableMFA" : "handleDisableMFA"].bind(
								this
							)}
							className="two-factor-auth-enable-btn">
							{!enabled ? translate("ENABLE_2FA") : translate("DISABLE")}
						</Button>
					</TwoFactorAuthWrapper>
				)}
			</Translate>
		);
	}
}
const mapStateToProps = (state) => ({});

const mapDispatchToProps = { enableMFA, verifyMFAToken, disableMfa, getUserInfo };

export default connect(mapStateToProps, mapDispatchToProps)(TwoFactorAuth);
